import axios from 'axios';
import { refreshAccessToken } from '../helpers/ms-graph-api';

const includeAzureJwt = async (config) => {
  const token = await refreshAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

export const containersApi = axios.create({
  baseURL: process.env.NEXT_PUBLIC_CONTAINERS_API,
  headers: {
    'Content-Type': 'application/json',
    changeOrigin: true,
  },
});

containersApi.interceptors.request.use(includeAzureJwt, (error) =>
  Promise.reject(error)
);

export const containersApiFormData = axios.create({
  baseURL: process.env.NEXT_PUBLIC_CONTAINERS_API,
  headers: {
    'Content-Type': 'multipart/form-data',
    changeOrigin: true,
  },
});

containersApiFormData.interceptors.request.use(includeAzureJwt, (error) =>
  Promise.reject(error)
);

export const containersApiBlob = axios.create({
  baseURL: process.env.NEXT_PUBLIC_CONTAINERS_API,
  responseType: 'blob',
  headers: {
    'Content-Type': 'application/json',
  },
});

containersApiBlob.interceptors.request.use(includeAzureJwt, (error) =>
  Promise.reject(error)
);

export const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    changeOrigin: true,
  },
});

export default {
  containersApi,
  containersApiBlob,
};
